import React, {useState} from 'react';
import {Link, useHistory, withRouter} from 'react-router-dom';
import {
    AppBar, Button, Divider, Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText,
    Toolbar, Typography
} from '@material-ui/core';
import {ChevronLeft, Dashboard, Home, Menu} from '@material-ui/icons';
import CountdownClock from './CountdownClock';
import SlideQuestionNumber from "./SlideQuestionNumber";
import {useRecoilValue} from "recoil";
import {lessonTypeState, testTypeState} from "../../states/test_progress_states";
import BorderLinearProgress from "./BorderLinearProgress";
import StyleHeader from "./styles/StyleHeader";
import TypeTest from "./TestType";
import TitleHeaderLeft from "./TitleHeaderLeft";
import LessonType from "./LessonType";
import withUrlParams from "../HOC/withUrlParams";
import withHeaderLogic from "../HOC/withHeaderLogic";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import i18n from 'i18next';
import {isOnlineState} from "../../states/states";
import queryString from 'query-string';

const Header = (props) => {
    const {
        uuid, testCode, currCode, isShowClock, isShowSlide, isShowProcessBar,
        isShowButtonHome, isResultDetail, isShowButtonViewResult
    } = props;
    const url = new URL(window.location.href)
    const [drawerOpen, setDrawerOpen] = useState(false);
    const testType = useRecoilValue(testTypeState);
    const lessonType = useRecoilValue(lessonTypeState);
    const isOnline = useRecoilValue(isOnlineState);
    const classes = StyleHeader();
    let history = useHistory();
    let currentUrl = history.location.pathname;
    let lessonCode =  queryString.parse(url.search).lesson_code;
    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };
    const handleChangeLanguage = (event) => {
        localStorage.setItem("language", event.target.value);
        window.location.reload();
    };

    // Drawer Side List Component
    //Phiên bản sau sẽ sử dụng
    const DrawerList = () => (
        <React.Fragment>
            <List className={classes.drawerList}>
                <Divider/>
                <Link to={`/?uuid=${uuid}`} onClick={toggleDrawer}>
                    <ListItem button>
                        <ListItemIcon className={classes.iconColor}>
                            <Home/>
                        </ListItemIcon>
                        <ListItemText primary={i18n.t('home_page')}/>
                    </ListItem>
                </Link>
                <Link to={`/my-courses?uuid=${uuid}`} onClick={toggleDrawer}>
                    <ListItem button>
                        <ListItemIcon className={classes.iconColor}>
                            <Dashboard/>
                        </ListItemIcon>
                        <ListItemText primary={i18n.t('study_program')}/>
                    </ListItem>
                </Link>
                <div className="list-language">
                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">{i18n.t('change_language')}</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={localStorage.getItem("language") ? localStorage.getItem("language") : ""}
                            onChange={handleChangeLanguage}
                        >
                            <MenuItem value={"vi"}>{i18n.t('vietnamese')}</MenuItem>
                            <MenuItem value={"en"}>{i18n.t('English')}</MenuItem>
                            <MenuItem value={"laos"}>{i18n.t('Laos')}</MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </List>
            <Divider/>
        </React.Fragment>
    );

    return (
        <AppBar position="static" className={classes.root}>
            <Toolbar variant="dense" component="nav" disableGutters>
                {isShowButtonHome ?
                    <Button color="inherit" onClick={toggleDrawer}>
                        <Menu/>
                    </Button> : ''}
                {!testCode && currentUrl.search('my-tests') !== -1 ? <TitleHeaderLeft text={i18n.t('recent_test').toUpperCase()}/>
                    : !testCode && currentUrl.search('my-courses') !== -1 ? <TitleHeaderLeft text={i18n.t('study_program_sort').toUpperCase()}/>
                        : !testCode && currentUrl.search('my-lessons') !== -1 ? <TitleHeaderLeft text={i18n.t('parts').toUpperCase()}/>
                            : lessonCode ? <TitleHeaderLeft text={<LessonType lessonID={lessonType}/>}/>
                                : !testCode ? <TitleHeaderLeft text={i18n.t('home_page').toUpperCase()}/> : ""}
                {testCode
                    ?
                    (
                        (testCode == 1531 || testCode == 1468) ?

                            <Typography variant="h6" className={classes.appTitleHeading} edge="start">
                                THI CÁN BỘ
                            </Typography>

                            :
                            <Typography variant="h6" className={classes.appTitleHeading} edge="start">
                                <TypeTest testType={testType}/>
                            </Typography>
                    )

                    : ""}

                {isResultDetail
                    ? <Typography variant="h6" className={classes.resultTest} edge="start"
                                  onClick={() => {
                                      if(testCode && isOnline){
                                          history.push(`/result?test_code=${testCode}&uuid=${uuid}`);
                                      }else if(isOnline){
                                          history.push(`/result?uuid=${uuid}&curr_code=${currCode}&lesson_code=${lessonCode}`);
                                      }
                                  }}>
                        {i18n.t('list_result').toUpperCase()} 
                    </Typography> : ""}
                {/*CountdownClock*/}
                <div className={"CountdownClock"}>
                    <CountdownClock isShowClock={isShowClock}/>
                </div>
                {isShowButtonViewResult ?
                        <Typography variant="h6" className={classes.resultTest} 
                                    onClick={() => {
                                        if(isOnline){
                                            history.push(testCode
                                                ? `/result?test_code=${testCode}&uuid=${uuid}`
                                                : `/result?uuid=${uuid}&curr_code=${currCode}&lesson_code=${lessonCode}`)
                                        }
                                    }}>
                            {i18n.t('result').toUpperCase()}
                        </Typography>
                        :
                        <></>}
                {currCode && !lessonCode ?
                        <Typography variant="h6" className={classes.resultTest}
                                    onClick={() => {
                                        isOnline && history.push(`/my-courses?uuid=${uuid}`)
                                    }}>
                            {i18n.t('study_program_sort').toUpperCase()}
                        </Typography> : ""}
            </Toolbar>

            <Drawer open={drawerOpen} anchor="left" onClose={toggleDrawer} variant="temporary">
                <div className={classes.drawerHeader}>
                    <IconButton onClick={toggleDrawer} className={classes.iconColor}>
                        <ChevronLeft/>
                    </IconButton>
                </div>
                <DrawerList/>
            </Drawer>
            <SlideQuestionNumber isShowSlide={isShowSlide}/>
            <BorderLinearProgress testType={testType} lessonType={lessonType} isShowProcessBar={isShowProcessBar}/>
        </AppBar>
    );
};

export default withUrlParams(withHeaderLogic(withRouter(Header)));
